<template>
  <div>
    <Carousel class="review-card__container mt-4" :settings="settings" :breakpoints="breakpoints">
      <Slide class="review-card" v-for="(review, i) in reviews" :key="i">
        <div class="review-card__content">
          <div class="d-flex align-items-start">
            <img :src="review.values.photo_url.value" loading="lazy" class="avatar-small">
            <div class="d-flex flex-column align-items-start">
              <span class="review-card__name">
                {{ review.values.author_name.value }}
              </span>
              <span class="review-card__date">
                <span v-if="review.values.timestamp.value">
                  {{ formatDate(review.values.timestamp.value) }}
                </span>
              </span>
            </div>
          </div>
          <div class="stars-container mb-2 mt-3">
            <img :src="'https://spacebarprod-16905.kxcdn.com/public-assets/star-border'" class="star-border"
              alt="Active star review" loading="lazy" v-for=" n in 5" :key="n + ' active star'">
            <div class="d-flex">
              <div class="star-yellow__container" v-for="n in review.values.rating.value" :key="n + ' non active star'">
                <img :src="'https://spacebarprod-16905.kxcdn.com/public-assets/star-active'" loading="lazy" class="star-yellow"
                  alt="Non active star">
              </div>
            </div>
          </div>
          <div class="p-read-more-cont">
            <div class="p-read-more" ref="reviewCardPCont">
              <p class="review-card__p" ref="reviewCardP" v-if="review.values.review.value">
                {{ review.values.review.value }}
              </p>
              <div v-if="showReadMore[i]">
                <button class="read-more" @click="readMore(i)">
                  {{ showReadMore[i] ? (locale === 'es' ? 'Leer más' : 'Read More') : (locale === 'es' ? 'Leer menos' : 'Read Less') }}
                </button>
              </div>
              <div v-else-if="showReadLess[i]">
                <button class="read-more" @click="readMore(i)">
                  {{ showReadMore[i] ? (locale === 'es' ? 'Leer más' : 'Read More') : (locale === 'es' ? 'Leer menos' : 'Read Less') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Slide>
      <template #addons>
        <Navigation />
      </template>
    </Carousel>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { Carousel, Navigation, Slide } from 'vue3-carousel'
import Moment from 'moment'

export default defineComponent({
  name: 'Breakpoints',
  inject: ["locale", "$axios"],
  components: {
    Carousel,
    Slide,
    Navigation
  },
  props: {
    reviews: Array,
    // productSlugToHide: String
  },
  data: () => ({
    // carousel settings
    showReadMore: [],
    showReadLess: [],
    settings: {
      itemsToShow: 1.2,
      snapAlign: 'center',
    },
    prices: {},
    status: {
      prices: { loading: false }
    },
    // breakpoints are mobile first
    // any settings not specified will fallback to the carousel settings
    breakpoints: {
      400: {
        itemsToShow: 1.1,
        snapAlign: 'start',
      },
      480: {
        itemsToShow: 1.2,
        snapAlign: 'start',
      },
      575: {
        itemsToShow: 1.6,
        snapAlign: 'start',
      },
      768: {
        itemsToShow: 2.1,
        snapAlign: 'start',
      },
      1000: {
        itemsToShow: 2.8,
        snapAlign: 'start',
      },
      1199: {
        itemsToShow: 3.6,
        snapAlign: 'start'
      }
    }
  }),
  methods: {
    readMore(i) {
      if (this.$refs.reviewCardPCont[i].classList.contains('open')) {
        this.$refs.reviewCardPCont[i].classList.remove('open');
        this.$refs.reviewCardP[i].classList.remove('open');
        this.showReadMore[i] = true;
        this.showReadLess[i] = false;
      }
      else {
        this.$refs.reviewCardPCont[i].classList.add('open')
        this.$refs.reviewCardP[i].classList.add('open')
        this.showReadMore[i] = false;
        this.showReadLess[i] = true;
      }
    },
    formatDate(date) {
      if (date) {
        let format = locale === 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
        return Moment.unix(date).local().format(format);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let paragraphs = this.$refs.reviewCardP;
      paragraphs.forEach((paragraph, i) => {
        if (paragraph.getBoundingClientRect().height > 40) {
          this.showReadMore[i] = true;
        }
      });
    });
  }
})
</script>
<style>
.carousel__viewport {
  overflow: initial !important;
}
</style>
<style lang="scss" scoped>
@import 'https://cdn.jsdelivr.net/npm/vue3-carousel@0.2.9/dist/carousel.min.css';

.avatar-small {
  width: 55px;
  height: 55px;
  background-color: var(--light);
  border-radius: 50%;
  margin-right: 15px;
}

.review-card {
  padding: 5px 4px;
  background-color: transparent;

  .review-card__content {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 15px;
    padding-bottom: 0;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0px 0px 7px 4px rgba(0, 0, 0, 0.05);
    margin: 10px !important;
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
    justify-content: flex-start !important;

    span {
      text-align: left;
    }

    &::after {
      position: absolute;
      content: "";
      top: 15px;
      right: 15px;
      width: 25px;
      height: 25px;
      background: url(https://spacebarprod-16905.kxcdn.com/public-assets/g-icon);
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

}

.review-card__name {
  font-weight: 600;
  font-size: 15px;
  max-width: 188px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  @media screen and (max-width:575px) {
    margin-right: 30px;
  }
}

.review-card__date {
  font-weight: 300;
  color: rgb(176, 176, 176);
  font-size: 12px;
  span{
    font-weight: 600;
    color: rgb(176, 176, 176) !important;
  }
}

.star-border {
  width: 12px;
  height: 12px;
  object-fit: contain;
  opacity: .4;
  margin-right: 7px;
}

.star-yellow__container {
  width: 12;
  height: 12px;

  .star-yellow {
    width: 100%;
    height: 100%;
    opacity: 1;
    margin-right: 7px;
    object-fit: contain;
    object-position: left;

  }
}

.stars-container {
  position: relative;
  display: flex;

  div.d-flex {
    position: absolute;
  }
}

.p-read-more-cont {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  position: relative;
  background-color: white;
  min-height: 120px;

}

.p-read-more {
  position: relative;
  background-color: white;
  left: -15px;
  width: calc(100% + 30px);
  padding-inline: 15px;
  z-index: 3;
  min-height: calc(100% + 15px);
  -webkit-box-shadow: 0px 7px 4px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0px 7px 4px 5px rgba(0, 0, 0, 0.03);
  border-radius: 0 0 10px 10px;

  &.open {
    position: absolute;
    padding-bottom: 20px;

    .read-more {
      color: rgb(84, 84, 84);
      font-size: 14px;
      text-transform: capitalize;
      text-decoration: underline;
      bottom: -20px;
      position: absolute;
      left: 0;
      width: 100%;
      padding-left: 15px;
      -webkit-box-shadow: 0px 7px 4px 5px rgba(0, 0, 0, 0.03);
      box-shadow: 0px 7px 4px 5px rgba(0, 0, 0, 0.03);
      height: 40px;
      padding-bottom: 10px;
    }
  }

  .read-more {
    color: rgb(84, 84, 84);
    font-size: 14px;
    text-transform: capitalize;
    text-decoration: underline;
    bottom: 0;
    background-color: white;
    left: 0;
    width: 100%;
    text-align: left;
    border-radius: 0 0 10px 10px;
    padding-top: 10px;
  }
}



.review-card__p {
  font-size: 13px;
  font-weight: 300;
  text-align: left;
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;

  &.open {
    overflow-wrap: normal;
    display: flex;
    -webkit-line-clamp: initial;
    -webkit-box-orient: initial;
    overflow-y: scroll;
    overflow-x: hidden;
    text-overflow: initial;
    max-height: 170px;
  }
}
</style>
